function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionEcl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5900_80906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0.5C15.525 0.5 20 4.975 20 10.5C20 16.025 15.525 20.5 10 20.5C4.475 20.5 0 16.025 0 10.5C0 4.975 4.475 0.5 10 0.5ZM10 1.75C5.1625 1.75 1.25 5.6625 1.25 10.5C1.25 15.3375 5.1625 19.25 10 19.25C14.8375 19.25 18.75 15.3375 18.75 10.5C18.75 5.6625 14.8375 1.75 10 1.75ZM10 14.5C10.1231 14.5 10.245 14.5242 10.3588 14.5714C10.4725 14.6185 10.5759 14.6875 10.6629 14.7746C10.75 14.8616 10.819 14.965 10.8661 15.0787C10.9132 15.1925 10.9375 15.3144 10.9375 15.4375C10.9375 15.5606 10.9132 15.6825 10.8661 15.7963C10.819 15.91 10.75 16.0134 10.6629 16.1004C10.5759 16.1875 10.4725 16.2565 10.3588 16.3036C10.245 16.3508 10.1231 16.375 10 16.375C9.75136 16.375 9.5129 16.2762 9.33709 16.1004C9.16127 15.9246 9.0625 15.6861 9.0625 15.4375C9.0625 15.1889 9.16127 14.9504 9.33709 14.7746C9.5129 14.5988 9.75136 14.5 10 14.5ZM10 4.1875C10.8288 4.1875 11.6237 4.51674 12.2097 5.10279C12.7958 5.68884 13.125 6.4837 13.125 7.3125C13.125 7.96625 12.9162 8.46625 12.5962 8.8625C12.3704 9.13164 12.1078 9.36769 11.8162 9.56375L11.6075 9.71C11.28 9.9375 11.0437 10.1062 10.875 10.3137C10.7022 10.5235 10.6131 10.7898 10.625 11.0613V12.3113C10.625 12.477 10.5592 12.636 10.4419 12.7532C10.3247 12.8704 10.1658 12.9363 10 12.9363C9.83424 12.9363 9.67527 12.8704 9.55806 12.7532C9.44085 12.636 9.375 12.477 9.375 12.3113V11.0613C9.375 10.4125 9.585 9.91625 9.90625 9.52375C10.1375 9.24125 10.4225 9.01875 10.6763 8.83625L10.8925 8.685C11.2175 8.45875 11.4538 8.28875 11.6225 8.07875C11.7985 7.86334 11.8885 7.59035 11.875 7.3125C11.875 6.81522 11.6775 6.33831 11.3258 5.98667C10.9742 5.63504 10.4973 5.4375 10 5.4375C9.50272 5.4375 9.02581 5.63504 8.67417 5.98667C8.32254 6.33831 8.125 6.81522 8.125 7.3125C8.125 7.47826 8.05915 7.63723 7.94194 7.75444C7.82473 7.87165 7.66576 7.9375 7.5 7.9375C7.33424 7.9375 7.17527 7.87165 7.05806 7.75444C6.94085 7.63723 6.875 7.47826 6.875 7.3125C6.875 6.4837 7.20424 5.68884 7.79029 5.10279C8.37634 4.51674 9.1712 4.1875 10 4.1875Z",
    fill: "#99ABA7",
    style: {
      fill: "#99ABA7",
      fill: "color(display-p3 0.6000 0.6706 0.6549)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5900_80906"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(0 0.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionEcl);
export default __webpack_public_path__ + "static/media/questionECL.1e378196f00cd87d2fe03a4ac2cd7299.svg";
export { ForwardRef as ReactComponent };